/**
 * GENERATED by scripts/build-logo-map.mjs - do not edit by hand.
 *
 * Each vendor's own mark, served from our own origin. Self-hosted on purpose:
 * a logo CDN would mean every tenant's browser announcing to a third party
 * which backup vendors that MSP runs, on every page view. That is customer
 * intelligence, and it is not ours to leak.
 *
 * Absence is normal and handled - a vendor with no file here gets the
 * generated initials mark instead, which is why this map is allowed to be
 * incomplete rather than being a list everything must appear in.
 */
export const VENDOR_LOGOS: Record<string, string> = {
  acronis: '/logos/acronis.svg',
  autotask: '/logos/autotask.svg',
  avepoint: '/logos/avepoint.svg',
  "aws-backup": '/logos/aws-backup.png',
  "axcient-x360cloud": '/logos/axcient-x360cloud.png',
  "axcient-x360recover": '/logos/axcient-x360recover.png',
  comet: '/logos/comet.webp',
  connectwise: '/logos/connectwise.png',
  cove: '/logos/cove.svg',
  dropsuite: '/logos/dropsuite.png',
  druva: '/logos/druva.png',
  itglue: '/logos/itglue.png',
  keepit: '/logos/keepit.png',
  "m365-azure": '/logos/m365-azure.ico',
  nsight: '/logos/nsight.svg',
  "proxmox-pbs": '/logos/proxmox-pbs.png',
  "rapidfire-grc": '/logos/rapidfire-grc.jpg',
  resend: '/logos/resend.png',
  "veeam-vspc": '/logos/veeam-vspc.png',
};

/** The path for a vendor, or null when we do not have their mark. */
export function logoFor(id: string): string | null {
  return VENDOR_LOGOS[id] ?? null;
}
